<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 d-flex justify-content-end">
            <select name="" id="" class="form-control mr-3" style="width:20%">
              <option value="">--Branch--</option>
              <option value=""></option>
              <option value=""></option>
            </select>
            <ts-input v-model="search" placeholder="Search" style="width:20%" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.branch.branch_name_en }}</td>
          <td class="kh-font">{{ record.name_kh }}</td>
          <td>{{ record.name_en }}</td>
          <td>{{ record.phone }}</td>
          <td>{{ record.address }}</td>
          <td class="text-center">
            <a href="#" title="edit" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>

            <a href="#" title="delete" class="text-danger" @click="destroy(record)">
              <i class="fas fa-circle-notch spin spiner" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-if="record._deleting == false"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  props: ['fetch'],
  name: 'vendor-profile-table',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'branch' },
        { name: 'name kh' },
        { name: 'name en' },
        { name: 'phone number', style: 'width:20%' },
        { name: 'Address' },
        { name: 'action', style: 'text-align:center; width:5%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('inventory/foodCourt', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.inventory.foodCourt.search
      },
      set(newValue) {
        this.$store.commit('inventory/foodCourt/SET_SEARCH', newValue)
        this.$store.commit('inventory/foodCourt/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attribute) {
      this.loading = true
      this.$store
        .dispatch('inventory/foodCourt/fetch')
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    edit(record) {
      this.$store.commit('inventory/foodCourt/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'food-court-edit',
        params: { id: record.foodcourt_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('inventory/foodCourt/delete', record.foodcourt_id)
          .then(response => {
            record._deleting = false
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            record._deleting = false
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    fetch: function(value) {
      if (value) {
        this.fetchData()
        this.$emit('fetched')
      }
    },
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
